// Publisher-page slug helpers, shared by the /publisher pages, the
// product/search publisher links and the publisher sitemap.
//
// Every brand facet returned by the search aggregations gets a "virtual"
// publisher page at /publisher/<slugifyBrand(brand)> even without a CMS entry,
// so this slug transform must stay in sync everywhere a publisher link is
// built or resolved (lowercase, spaces→dash, strip everything else).
// Display name for a license facet code: "harry_potter" → "Harry Potter",
// "dc_comics" → "DC Comics", "magic_the_gathering" → "Magic the Gathering".
// A CMS entry's name always overrides this.
const NAME_STOPWORDS = new Set(["the", "and", "of", "a", "in", "de", "la"]);
export const prettyLicenseName = (code: unknown): string =>
  String(code ?? "")
    .split(/[\s_]+/)
    .filter(Boolean)
    .map((w, i) =>
      w.length <= 3 && !NAME_STOPWORDS.has(w.toLowerCase())
        ? w.toUpperCase()
        : i > 0 && NAME_STOPWORDS.has(w.toLowerCase())
          ? w.toLowerCase()
          : w.charAt(0).toUpperCase() + w.slice(1),
    )
    .join(" ");

// Underscores map to dashes too: license facet keys are PIM codes like
// "harry_potter" → "harry-potter".
export const slugifyBrand = (value: unknown): string =>
  String(value ?? "")
    .toLowerCase()
    .replace(/[\s_]+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-{2,}/g, "-")
    .replace(/^-+|-+$/g, "");
